import React, { useEffect, useState } from 'react';
import faqServices from '../../services/faq.services';
import Accordion from 'react-bootstrap/Accordion';

const Faq = () => {
    const [faqData, setFaq] = useState([])
 
    const faqList = [
        {
            _id: 1,
            question: "Why can’t Testigo provide a list of clinic addresses, names, and phone numbers?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        },
        {
            _id: 2,
            question: "I have claustrophobia, do you have an open MRI?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        },
        {
            _id: 3,
            question: "I have claustrophobia, do you have an open MRI?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        },
        {
            _id: 4,
            question: "What should I expect after I complete my exam?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        },
        {
            _id: 5,
            question: "Can I have a procedure performed without a referring physician?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        },
        {
            _id: 6,
            question: "sss Are there people who shouldn't have an MRI scan?",
            ans: "Testigo Imaging’s services do not include walk-ins to imaging facilities. To curtail walk-ins from occurring, we do not share clinic information until a patient schedules an appointment."
        }
    ]

    useEffect(()=>{
        const getFaqData =async()=>{
            const result = await faqServices.getFaqList()
            if(result){
                setFaq(result.data.fqa.length>0 ? result.data.fqa:faqList)    
            }
        }
        getFaqData()
    },[])

    return (
        <section className="faq-sec">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="faq-header text-center">
                            <h6 className="small-heading aos-init aos-animate" data-aos="fade-up">Faq</h6>
                            <h3 className="heading-gradient aos-init aos-animate" data-aos="fade-up">Freqently Asked Questions</h3>
                        </div>
                        <div className="faq-body">
                            <div className="row accordion" id="faqlist">
                                {
                                    faqData.map((item,index) => {
                                        return (
                                            <div className="col-lg-4 col-md-6 mt-4" key={item._id}>
                                            <Accordion>
                                                <Accordion.Item eventKey={item._id} data-aos="fade-up" data-aos-duration={1500}>
                                                    <Accordion.Header>
                                                    {item.question}
                                                    <hr />
                                                    <div className="plus-icon" />
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                    {item.ans}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;